import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import CallUpload from './pages/CallUpload';
import CallLogs from './pages/CallLogs';
import Settings from './pages/Settings';
import CallDetail from './pages/CallDetail';
import Login from './pages/Login';
import Player from './pages/Player';
import AuthCallback from './pages/AuthCallback';
import { SellerCallTimeline } from './pages/SellerCallLogs';
import { AuthProvider, useAuth } from './context/AuthContext';

// Protected Route wrapper
const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center">
        <div className="text-center">
          <div className="relative mb-6">
            <div className="w-16 h-16 border-4 border-slate-200 rounded-full mx-auto"></div>
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-16 h-16 border-4 border-[#2eb4ac] border-t-transparent rounded-full animate-spin"></div>
          </div>
          <p className="text-slate-600 font-medium">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

// Router component that handles auth callback detection
const AppRouter = () => {
  const location = useLocation();
  
  // Check URL fragment (not query params) for session_id - must be synchronous
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      {/* Public, chrome-less audio player — used by export CSV links */}
      <Route path="/player" element={<Player />} />
      <Route path="/" element={
        <ProtectedRoute>
          <Layout />
        </ProtectedRoute>
      }>
        <Route index element={<Dashboard />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="upload" element={<CallUpload />} />
        <Route path="call-logs" element={<CallLogs />} />
        <Route path="seller-calls/:phone" element={<SellerCallTimeline />} />
        <Route path="calls/:callId" element={<CallDetail />} />
        <Route path="settings" element={<Settings />} />
      </Route>
    </Routes>
  );
};

function App() {
  return (
    <>
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
      <Toaster />
    </>
  );
}

export default App;